module.exports = __webpack_public_path__ + "static/media/lower-rate-icon.7a27895e.svg";